var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicTacToe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 58,
    height: 58,
    rx: 16,
    fill: "#FDDB44",
    stroke: "#184985",
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#184985",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 14v36M38 14v36M14 26h36M14 38h36",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17 23 23M23 17 17 23",
    strokeWidth: 2.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 3.2,
    strokeWidth: 2.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicTacToe);
export default __webpack_public_path__ + "static/media/tic-tac-toe.d3048a957eccc63188e5ddcaad1e9069.svg";
export { ForwardRef as ReactComponent };